import { ColumnLookupRuleType, ColumnLookupTransform, ColumnLookupTransformConfig, ConditionEndType, ConditionStartType, LookupDedup } from 'src/app/domainObjects/transformers/columnLookupTransform';
import { DataFarmType } from 'src/app/domainObjects/dataFarmType';
import { ColumnLookupTransformPreviewDataResponse } from 'src/app/messaging/columnLookupTransformPreviewDataResponse';
import { PreviewDataImportRequest } from 'src/app/messaging/previewImportDataRequest';
import { ConfigService } from 'src/app/services/config/config.service';
import { DataFarmViewModel } from 'src/app/viewModels/dataFarmViewModel';
import { DataTransformConfigViewModel } from 'src/app/viewModels/dataTransformConfigViewModel';
import { TransformerViewModel } from '../../../transformer-list/transformer-list.component';
import { TransformDetailViewModelBase } from '../../../dataTransformConfig/transformers/base/base-transformer-ui/transformDetailViewModelBase';
import { DataDictionaryService } from '../../../../services/dataDictionary/data-dictionary.service';
import { ValidationInfo, RequiredFieldValidation } from 'src/app/objectModel/validationInfo';
import { ColumnLookupRuleViewModel } from './columnLokupRuleViewModel';
import { SortInfo } from 'src/app/domainObjects/sortInfo';
import { IncludeInfo } from 'src/app/domainObjects/includeInfo';
import { TransformerParametersViewModel } from '../transformer-parameters/transformerParametersViewModel';
import { TransformType } from 'src/app/domainObjects/transformType';


export class ColumnLookupRuleTypeUtil {
    static toString(ruleType: ColumnLookupRuleType, isStart: boolean): string {
        switch (ruleType) {
            case ColumnLookupRuleType.contains: return 'Contains';
            case ColumnLookupRuleType.group: return isStart ? 'Group Start' : 'Group End';
        }
    }
}

export class ConditionStartTypeUtil {
  static toString(condType: ConditionStartType): string {
      switch (condType) {
        case ConditionStartType.Contents: return 'Contents';
        case ConditionStartType.LeftChars: return 'Left Chars';
        case ConditionStartType.RightChars: return 'Right Chars';
        case ConditionStartType.Before: return 'Before';
        case ConditionStartType.After: return 'After';
        case ConditionStartType.Between: return 'Between';
      }
  }
}

export class ConditionEndTypeUtil {
  static toString(condType: ConditionEndType): string {
      switch (condType) {
        case ConditionEndType.Contents: return 'Contents';
        case ConditionEndType.LeftChars: return 'Left Chars';
        case ConditionEndType.RightChars: return 'Right Chars';
        case ConditionEndType.Before: return 'Before';
        case ConditionEndType.After: return 'After';
        case ConditionEndType.Between: return 'Between';
      }
  }
}

export class LookupDedupUtil {
  static toString(condType: LookupDedup): string {
      switch (condType) {
        case LookupDedup.KeepLast: return 'Keep Last';
        case LookupDedup.KeepFirst: return 'Keep First';
        case LookupDedup.NoDedup: return 'No Dedup';
      }
  }
}

export class ColumnLookupTransformDetailViewModel extends TransformDetailViewModelBase<ColumnLookupTransform> {
  farmType: DataFarmType;
  defKeyField:string;
  defLookupField: string;
  lookupFarm: string;
  lookupDedup?: number;
  runAll: boolean;
  overwriteRows: boolean;
  resetRows: boolean;
  lookupFarmType:string;
  farm : string;
  sourceDataFarm:string;
  //sourceDataFarmType:string;
  targetColumn: string;
  sourceColumn: string;

  lookupColumns: Array<string>;

  rules: Array<ColumnLookupRuleViewModel> = [];

  parameters:TransformerParametersViewModel;

  dataFarm: DataFarmViewModel;
  // Preview options
  rows: number;
  sampleStart: number;
  sampleEnd: number;
  // Status
  groupHitCount?: number;
  hitCount?: number;
  missCount?: number;
  hitRatio?: number;
  hitRatioDisplay?: string;

  request: PreviewDataImportRequest;
  response: ColumnLookupTransformPreviewDataResponse;

    constructor(
      dataDictService: DataDictionaryService,
      private configService: ConfigService,
      configViewModel: DataTransformConfigViewModel,
      transformViewModel: TransformerViewModel) {
        super(dataDictService, configViewModel, transformViewModel);

        const transformConfig = this.transform.transformConfig;
        this.parameters=new TransformerParametersViewModel();
        if (transformConfig) {
          this.lookupFarm = transformConfig.lookupFarm;
          this.lookupFarmType =this.ConvertEnumToString(transformConfig.lookupFarmType);
          
          this.sourceColumn = transformConfig.defSourceField;
          this.targetColumn = transformConfig.defTargetField;

          this.defKeyField = transformConfig.defKeyField;
          this.defLookupField = transformConfig.defLookupField;
          this.lookupDedup=transformConfig.lookupDedup;
          this.sampleEnd = transformConfig.sampleEnd + 1;
          this.sampleStart = transformConfig.sampleStart + 1;
          this.runAll = transformConfig.runAll;
          this.farm = transformConfig.farm;
          this.farmType = transformConfig.farmType ?? transformViewModel.transform.dataFarmType;//this.ConvertEnumToString(transformConfig.farmType);//transformConfig.farmType ?? transformViewModel.transform.dataFarmType;
          this.sourceDataFarm = transformConfig.sourceDataFarm;
          //this.sourceDataFarmType =this.ConvertEnumToString(transformConfig.sourceDataFarmType);
          this.sortInfo = transformConfig.sortInfo;
          if(transformConfig.includeInResults){
            this.includeInResults = transformConfig.includeInResults.map(item =>new IncludeInfo(item));
            this.parameters.includeInResults=this.includeInResults;
          }
          //parameters
          this.parameters.sortInfo= transformConfig.sortInfo;
          //this.parameters.includeInResults= transformConfig.in;
          this.parameters.sampleStart = transformConfig.sampleStart+ 1;
          this.parameters.sampleEnd = transformConfig.sampleEnd+ 1;
          this.parameters.runAll= transformConfig.runAll;
          
          this.resetRows = transformConfig.resetRows;
          this.overwriteRows = transformConfig.overwriteRows;

          if (transformConfig.rules) {
            this.rules = transformConfig.rules.map(r => new ColumnLookupRuleViewModel(r));
          }
        }
    }
public ConvertEnumToString(requst:number): string{
  var ret:string="";
  if(requst==DataFarmType.subTask){
    ret = "Subtask";
  }
  else if(requst==DataFarmType.task){
    ret = "Task";
  }
  else if(requst==DataFarmType.activity){
    ret = "Activity";
  }
  else if(requst==DataFarmType.cases){
    ret = "Case";
  }
  else if(requst== DataFarmType.users){
    ret ="User";
  }
  else if(requst==DataFarmType.behaviors){
    ret = "Behavior";
  }
  else if(requst==DataFarmType.master){
    ret = "Master";
  }
  return ret;
}
ConvertStringToEnum(requst:string): number{
  var ret:number=-1;
  if(requst=="Subtask"){
    ret = DataFarmType.subTask;
  }
  else if(requst=="Task"){
    ret = DataFarmType.task;
  }
  else if(requst=="Activity"){
    ret = DataFarmType.activity;
  }
  else if(requst=="Case"){
    ret = DataFarmType.cases;
  }
  else if(requst=="User"){
    ret = DataFarmType.users;
  }
  else if(requst=="Behavior"){
    ret = DataFarmType.behaviors;
  }
  else if(requst=="Master"){
    ret =DataFarmType.master;
  }
  return ret;
}
    override configureValidationInfo(): ValidationInfo[] {
      const infos = [];

      // infos.push( new RequiredFieldValidation('groupByField', 'Group By'));
      // infos.push( new RequiredFieldValidation('userField', 'User Field'));
      // infos.push( new RequiredFieldValidation('timestampField', 'Timestamp Field'));
      infos.push( new RequiredFieldValidation('lookupFarm', 'Lookup Farm'));
      infos.push( new RequiredFieldValidation('defLookupField', 'Lookup Field'));
      return infos;
    }

    reindexRules(): void {
      for (let i = 0; i < this.rules.length; i++) {
        this.rules[i].index = i + 1;
      }
      this.rules.sort((a, b) => a.index - b.index);
    }

    public override toTransformConfig(): ColumnLookupTransformConfig {
      const config = new ColumnLookupTransformConfig();
      config.farmType = this.farmType;
      config.transformType = TransformType.columnLookup;
      config.defKeyField = this.defKeyField;
      config.defLookupField = this.defLookupField;
      config.lookupFarm = this.lookupFarm;
      config.lookupDedup=this.lookupDedup;
      if(this.parameters.sortInfo){
        if(this.parameters.sortInfo.length==0){
          config.sortInfo =undefined;
        }else{
          config.sortInfo=this.parameters.sortInfo;
        }
      }
      if(this.parameters.includeInResults){
        if(this.parameters.includeInResults.length==0){
          config.includeInResults =undefined;
        }else{
          config.includeInResults =this.parameters.includeInResults.map(item => item.includeField);
        }
      }
      config.sampleStart =this.parameters.sampleStart-1;
      config.sampleEnd =this.parameters.sampleEnd-1;
      config.runAll=this.parameters.runAll;
      config.overwriteRows = this.overwriteRows;
      config.resetRows = this.resetRows;
      config.lookupFarmType=this.ConvertStringToEnum(this.lookupFarmType);
      config.farm = this.farm;     
      config.sourceDataFarm = this.sourceDataFarm;
      //config.sourceDataFarmType=this.ConvertStringToEnum(this.sourceDataFarmType);

      config.rules = this.rules.map(r => {
        const rule = r.toRule();
        if (rule.targetField == null) {
          rule.targetField = config.defTargetField;
        }
        return rule;
      });

      return config;
    }

    public override onTransformRunCompleted(response: ColumnLookupTransformPreviewDataResponse): void {
      // A cache-hit run carries no stats at all (they're deliberately stripped
      // before a CachedProcessingResult is persisted -- see
      // project_stats_vs_fullrun_separation memory). Nothing has changed since
      // whatever last populated the stats currently on screen, so they're still
      // accurate -- leave them exactly as they are instead of wiping them blank.
      if (
        !response?.previewStats ||
        !response?.totalStats ||
        !response.totalStats.ruleStats ||
        !response.previewStats.ruleStats
      ) {
        return;
      }

      // Clear all stats prior to rebinding new values
      this.groupHitCount = null;
      this.hitCount = null;
      this.hitRatio = null;
      this.missCount = null;
      this.hitRatioDisplay = '0.00%';
      this.rows = 0;
      this.rules.forEach( r => {
        r.mergeHits = null;
        r.lookupHits = null;
      });
      // map the rule stats to the rule
      if (response.previewStats.ruleStats) {
        for (let i = 0; i < this.rules.length; i++) {
          const ruleStat = response.previewStats.ruleStats.find(r => r.ruleIndex === i);
          this.rules[i].mergeHits = ruleStat?.groupHits;
          this.rules[i].lookupHits = ruleStat?.rowHits;
        }
      }
      this.rows = this.runAll ? response.currentData?.totalRows : response.activeData?.totalRows;

      if (response.previewStats.globalStat) {
        this.groupHitCount = response.previewStats.globalStat.groupHits;
        this.hitCount = response.previewStats.globalStat.rowHits;
        this.missCount = response.previewStats.globalStat.rowMisses;
        if (response.previewStats.globalStat.hitRate) {
          this.hitRatio = response.previewStats.globalStat.hitRate;
          this.hitRatioDisplay = `${(this.hitRatio * 100).toFixed(2)}%`;
        }
      }

      // map the rule stats to the rule
      if (response.totalStats.ruleStats) {
        for (let i = 0; i < this.rules.length; i++) {
          const ruleStat = response.totalStats.ruleStats.find(r => r.ruleIndex === i);
          this.rules[i].mergeHits = ruleStat?.groupHits;
          this.rules[i].lookupHits = ruleStat?.rowHits;
        }
      }
      if (response.totalStats.globalStat) {
        this.groupHitCount = response.totalStats.globalStat.groupHits;
        this.hitCount = response.totalStats.globalStat.rowHits;
        this.missCount = response.totalStats.globalStat.rowMisses;
        if (response.totalStats.globalStat.hitRate) {
          this.hitRatio = response.totalStats.globalStat.hitRate;
          this.hitRatioDisplay = `${(this.hitRatio * 100).toFixed(2)}%`;
        }
      }
    }

}
